import React, { useState, useEffect } from "react";
import { format, parse } from "date-fns";
import { datePickerIcon } from "../../../assetData/icons";
import { cn } from "../../../utils/twMerge";
import "./styles.css";

const CustomDateInput = ({
  initialValue,
  className,
  handleSetValue,
  handleValue,
  form1,
  min,
  max,
  value,
  className1,
  name,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(() => initialValue ?? null);

  const formatDate = (rawDate) => {
    if (!rawDate) return;
    const parsedDate = parse(rawDate, "yyyy-MM-dd", new Date());
    const formattedDate = format(parsedDate, "dd MMM yyyy");
    return formattedDate;
  };

  const handleOnChange = (e) => {
    const date = e.target.value;
    if (date === "") {
      sessionStorage.removeItem(name);
    }
    setInputValue(formatDate(date));

    if (typeof handleSetValue === "function") {
      handleSetValue(date);
    }
  };

  useEffect(() => {
    if (!initialValue) setInputValue(null);
    setInputValue(() => {
      const formattedDate = formatDate(initialValue);
      return formattedDate;
    });
  }, [initialValue]);

  return (
    <div
      className={cn(
        "relative mt-1 flex w-max justify-between gap-1 bg-[#f5f5f5] px-3 py-2",
        className,
      )}
    >
      <div className={` text-base text-[#868686] ${className1}`}>
        {inputValue ?? "dd mmm yyyy"}
      </div>
      <img src={datePickerIcon} className="w-5" alt="" />
      <input
        {...form1}
        value={value}
        min={min}
        max={max}
        {...props}
        type="date"
        onChange={(e) => handleOnChange(e)}
        className="cus-date-input"
      />
    </div>
  );
};

export default CustomDateInput;
